import { ReactNode } from 'react';

import { Header } from 'components/Header';
import { useHistory } from 'utils/router';

export interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const history = useHistory();
  return (
    <>
      {!history.location.pathname.includes('sign-up') && <Header />}
      {children}
    </>
  );
};
